import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const BasketFeeContainer = styled.div`
  display: ${props => props.isExpanded ? 'none' : 'block'};
  background-color: ${props => props.isExpanded ? 'initial' : props.theme.menuPage.basket.total.backgroundColor};
  ${media.small`
    display: ${props => props.isExpanded ? 'block' : 'none'};
    margin-bottom: ${props => props.isExpanded ? '0' : '0.6rem'};
  `};
`;

export const BasketFeeStyled = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${p => p.theme.sideBasket.summary.fee.fontSize};
  color: ${props => props.theme.quaternaryColor};
  padding: ${props => props.theme.padding};
  border-top-color: ${props => props.theme.borderColor};
  border-top-width: ${props => props.theme.borderWidth};
  border-top-style: solid;
  font-weight: ${p => p.theme.sideBasket.summary.fee.fontWeight};
  ${media.small`
    color: ${props => props.theme.primaryColor};
    border-top: solid 1px ${props => props.theme.borderColorRevert};
    margin-top: 0;
    display: flex;
    align-items: flex-end;
    padding: 0.6rem 1.2rem;
    font-size: 1.6rem;
    line-height: 1.6rem;
  `};
`;



// WEBPACK FOOTER //
// ./components/BasketBar/BasketFee.style.js